import * as React from 'react'
import * as Exp from '../../../experimentConstants'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import Carousel from '../../organisms/carousel'
import { CarouselProvider } from '../../organisms/carousel/context'
import MediaQuery from 'react-responsive'
import TextSection from '../../atoms/text-section'
import { Breakpoints, Icon, Text } from '@doordash/design-language'
import { getHamburgerItem, HamEnum } from '../../atoms/hamburger-menu'
import { TextType } from '../../atoms/text-section/text-section'
import {
  SignUpDetailsWrapper,
  SignUpHeaderWrapper,
  SignUpDetailsSectionWrapper,
  DataWrapper,
  SignUpSubtitle,
  SignupCarouselWrapper,
} from './styles'
import { SignUpDetailsText, SignUpDetailsTextJP } from './constants'

type countryData = {
  isAU: boolean
  isCA: boolean
  isDE: boolean
  isJP: boolean
}

type SignupProps = {
  signUpDetailsTitle: string
  currentSignUpCountry: countryData
}

const SignUpCarouselComponent: React.FunctionComponent<SignupProps> = ({
  signUpDetailsTitle,
  currentSignUpCountry,
}) => {
  const signUpCard = currentSignUpCountry.isJP
    ? SignUpDetailsTextJP
    : SignUpDetailsText
  return (
    <SignUpDetailsSectionWrapper>
      <div>
        <SignUpHeaderWrapper>{signUpDetailsTitle}</SignUpHeaderWrapper>
      </div>
      <SignupCarouselWrapper>
        <CarouselProvider>
          <Carousel isFullScreen={false}>
            {signUpCard.content.map(data => {
              return (
                <div id={data.subtitle} key={data.subtitle}>
                  <DataWrapper>
                    <SignUpSubtitle>
                      <Icon size={Icon.Sizes.Small} type={data.iconType} />
                      <Text styles={Text.Styles.SectionTitle}>
                        {data.subtitle}
                      </Text>
                    </SignUpSubtitle>
                    <React.Fragment>
                      <ul>
                        {data.text.map((info, index) => (
                          <li key={info.concat(index.toString())}>
                            <Text styles={Text.Styles.PageDescriptionBody}>
                              {info}
                            </Text>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  </DataWrapper>
                </div>
              )
            })}
          </Carousel>
        </CarouselProvider>
      </SignupCarouselWrapper>
    </SignUpDetailsSectionWrapper>
  )
}

const SignupDetailsTextComponent: React.FunctionComponent<SignupProps> = ({
  signUpDetailsTitle,
  currentSignUpCountry,
}) => {
  return (
    <SignUpDetailsWrapper id={getHamburgerItem(HamEnum.SignUpDetails).anchor}>
      <TextSection
        title={signUpDetailsTitle}
        type={TextType.List}
        text={
          currentSignUpCountry.isJP ? SignUpDetailsTextJP : SignUpDetailsText
        }
        style={{ maxWidth: '768px', width: '100%' }}
      />
    </SignUpDetailsWrapper>
  )
}

const SignupDetails: React.FunctionComponent<SignupProps> = ({
  signUpDetailsTitle,
  currentSignUpCountry,
}) => {
  const isGraduationQ3 = isFeatureFlagEnabled(Exp.DX_CRO_LP_GRADUATION_Q3_2020)
  return (
    <React.Fragment>
      {isGraduationQ3 && (
        <React.Fragment>
          <MediaQuery maxWidth={Breakpoints.Mobile}>
            <SignUpCarouselComponent
              signUpDetailsTitle={signUpDetailsTitle}
              currentSignUpCountry={currentSignUpCountry}
            />
          </MediaQuery>
          <MediaQuery minWidth={Breakpoints.Mobile + 1}>
            <SignupDetailsTextComponent
              signUpDetailsTitle={signUpDetailsTitle}
              currentSignUpCountry={currentSignUpCountry}
            />
          </MediaQuery>
        </React.Fragment>
      )}
      {!isGraduationQ3 && (
        <SignupDetailsTextComponent
          signUpDetailsTitle={signUpDetailsTitle}
          currentSignUpCountry={currentSignUpCountry}
        />
      )}
    </React.Fragment>
  )
}

export default SignupDetails
